import React from 'react'
import { DownloadAnalyseModal } from '@placeme/components/molecules/DownloadAnalyseModal/DownloadAnalyseModal'
import useFeatureFlags from '@dataplace.ai/functions/hooks/useFeatureFlags'
import DownloadExcelButton, { DownloadExcelButtonProps } from './DownloadExcelButton'
import DownloadPdfButton, { DownloadComponentProps } from './DownloadPdfButton'
import DownloadAnalyse from './DownloadAnalyse'

type DownloadButtonTypes = DownloadExcelButtonProps & DownloadComponentProps & {
  wasLocationSaved: boolean
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function DownloadButtons({
  hasExcelAccess = false,
  isTrial,
  pdfDownloadDisabled,
  excelDownloadDisabled,
  reportId,
  isExcelLoading,
  setIsExcelLoading,
  comparedReportId,
  wasLocationSaved,
}: DownloadButtonTypes) {
  const { PDFv2 } = useFeatureFlags()

  return (
    <>
      {PDFv2
        ? (
          <DownloadAnalyse
            comparedReportId={comparedReportId}
            downloadDisabled={pdfDownloadDisabled}
            reportId={reportId}
            wasLocationSaved={wasLocationSaved}
          />
        )
        : (
          <DownloadAnalyseModal
            analyseId={reportId}
            trigger={(
              <DownloadPdfButton
                pdfDownloadDisabled={pdfDownloadDisabled}
              />
            )}
          />
        )}
      <DownloadExcelButton
        comparedReportId={comparedReportId}
        excelDownloadDisabled={excelDownloadDisabled}
        hasExcelAccess={hasExcelAccess}
        isExcelLoading={isExcelLoading}
        isTrial={isTrial}
        reportId={reportId}
        setIsExcelLoading={setIsExcelLoading}
      />
    </>
  )
}

export default DownloadButtons
